export default {
  sections: {
    setup_fee: {
      title: 'Custos de configuração',
      description: 'Custos de configuração a partir de {{amount}} – em vez de 1.000+',
    },
  },
  labels: {
    month: 'Mês (Líquido)',
    one_time_fee: 'Taxa única',
    more_options: 'Mais opções',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'A sua própria app na App Store e no Google Play',
    push_notifications: 'Notificações push para ofertas',
    loyalty: 'Fidelização de clientes através de programas de lealdade',
    offline_orders: 'Encomendas offline possíveis',
    individual_design: 'Design de app individual',
  },
  setup_fee_options: {
    150: 'Configuração padrão',
    75: 'Reduzido',
    0: 'Sem custos de criação',
  },
  feedback: {
    contract_signed_already: {
      title: 'O contrato já foi assinado',
      description: 'Contacte o suporte técnico se precisar de efetuar alterações',
    },
  },
};
